import axios, { AxiosRequestConfig } from 'axios';

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/scans`;
const API_URL_TICKETS = `${process.env.REACT_APP_API_BASE_URL}/api/tickets`;

export const getScans = async (branch: string, warehouse: string): Promise<string[]> => {
    try {
        const apiResponse = await axios.get<string[]>(`${API_URL}/${branch}/${warehouse}`);
        return apiResponse.data;
    } catch (error) {
        console.error(`Error fetching scans:`, error);
        throw error;
    }
};

export const processScans = async (payload: ProcessBatchRequest): Promise<{ batchId: string }> => {
    try {
        const apiResponse = await axios.post<{ batchId: string }>(`${API_URL}/process`, payload);
        return apiResponse.data;
    } catch (error) {
        console.error('Error processing scans:', error);
        throw error;
    }
};

export const getScanFileUrl = async (branch: string, warehouse: string, fileName: string): Promise<string> => {
    const config: AxiosRequestConfig = { responseType: 'blob'};
    try {
        const apiResponse = await axios.get(`${API_URL}/file/${branch}/${warehouse}/${fileName}`, config);
        const blob = new Blob([apiResponse.data], { type: 'application/pdf' });
        return URL.createObjectURL(blob);
    } catch (error) {
        console.error(`Error fetching scan file:`, error);
        throw error;
    }
};

export const deletePdf = async (branch: string, warehouse: string, fileName: string): Promise<boolean> => {
    try {
        const apiResponse = await axios.delete(`${API_URL}/file/${branch}/${warehouse}/${fileName}`);
        return apiResponse.status === 200;
    } catch (error) {
        console.error(`Error deleting PDF:`, error);
        throw error;
    }
};

export const getTicketMetadata = async (): Promise<TicketMetadata> => {
    try {
        const apiResponse = await axios.get<TicketMetadata>(`${API_URL_TICKETS}/metadata`);
        return apiResponse.data;
    } catch (error) {
        console.error("Error fetching ticket metadata dropdowns:", error);
        throw error;
    }
};

export interface TicketMetadata {
    vendors: Array<{ vendorId: string; vendorIddesc: string }>;
    freightVendors: Array<{ freightVendorId: string; freightVendorIddesc: string }>;
    inventoryItems: string[];
    coverSheetInventoryItems: Array<{ inventoryId: string; inventoryDesc: string; uom: string }>;
    locations: string[];
}

export interface CoverSheetHistoryLine {
    inventoryId: string;
    loads: number;
}

export interface CoverSheetHistoryEntry {
    batchId: string;
    orderDate: string;
    lines: CoverSheetHistoryLine[];
}

export const getCoverSheetHistory = async (branch: string, warehouse: string): Promise<CoverSheetHistoryEntry[]> => {
    try {
        const apiResponse = await axios.get<CoverSheetHistoryEntry[]>(`${API_URL}/history/${branch}/${warehouse}`, { params: { count: 40 } });
        return apiResponse.data;
    } catch (error) {
        console.error("Error fetching cover sheet history:", error);
        throw error;
    }
};

export interface CoverSheetRow {
    inventoryID: string;
    vendorID: string;
    freightVendorID: string;
    loads: number;
    receivedQty: number;
    uom: string;
}

export interface ProcessBatchRequest {
    branch: string;
    warehouse: string;
    coversheet: CoverSheetRow[];
    orderDate: string;
    note?: string;
}